import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "reports-page-table-column-size" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ReportsPageTableColumnLabelMono = _resolveComponent("ReportsPageTableColumnLabelMono")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_ReportsPageTableColumnLabelMono, null, {
      default: _withCtx(() => [
        _createTextVNode(_toDisplayString(_ctx.formattedSize), 1)
      ]),
      _: 1
    })
  ]))
}